















import Vue from 'vue';
import {Component,Prop} from 'vue-property-decorator';
import store from '../../store/index';
  @Component
  export default class Tags extends Vue{
    selectedTags:string[] = [];

    created() {
      this.$store.commit('fetchTags');
    }

    get tagList(){
        return this.$store.state.tagList;
      }
    toggle(tag:string){
      const index = this.selectedTags.indexOf(tag);
      if(index >= 0){
        this.selectedTags.splice(index,1);
      }else{
        this.selectedTags.push(tag);
      }
      this.$emit('update:value',this.selectedTags);
    }

    create() {
      const name = window.prompt('请输入标签名');
      if(!name){
        return window.alert("标签不能为空");
      }else{
        this.$store.commit('createTag',name);
      }
    }
    
  }
